{
  "dismiss": "Απόρριψη"
}
